import './ImageWithBackgroundBlock.scss';

import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';

import { ButtonV2, ButtonV2Props } from '../Button/ButtonV2';

const className = 'p-ImageWithBackgroundBlock';

type Props = {
  Title: ReactNode;
  Cta?: ReactElement<ButtonV2Props, typeof ButtonV2> | null;
  MainImage?: ReactNode;
};
const ImageWithBackground = ({ Title, Cta, MainImage }: Props) => {
  return (
    <div
      className={classNames(className, {
        [`${className}__with-image`]: MainImage,
      })}
    >
      <div className={`${className}__text-wrapper`}>
        <div className={`${className}__title`}>{Title}</div>
        {Cta && <div className={`${className}__cta`}>{Cta}</div>}
      </div>
      {MainImage && (
        <div className={`${className}__img-wrapper`}>{MainImage}</div>
      )}
    </div>
  );
};

export default ImageWithBackground;
